import { useAsObservableSource, useLocalStore } from 'mobx-react-lite';

import { useTranslation } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import { Features } from 'APP/packages/features/Features';
import { Group } from 'APP/store/Groups/Group';
import Entities from 'STORE';

import { updateDeepLink } from './Tasks/updateDeepLink';

interface IGroupUpdateLinkButtonPresenterParams {
  group: Group;
}

interface IGroupUpdateLinkButtonPresenter {
  isAvailableUpdateDeepLinkHash: boolean;
  onUpdateDeepLink(): void;
}

export const useGroupUpdateLinkButtonPresenter = ({
  group,
}: IGroupUpdateLinkButtonPresenterParams): IGroupUpdateLinkButtonPresenter => {
  const { t } = useTranslation();
  const source = useAsObservableSource({ group });

  const presenter = useLocalStore<IGroupUpdateLinkButtonPresenter>(() => ({
    get isAvailableUpdateDeepLinkHash(): boolean {
      if (!source.group || !source.group.withMeInAdmins || !Features.isRefreshDeeplinkEnabled()) {
        return false;
      }

      return source.group.isChatGroup || (source.group.isChannel && source.group.isOpen);
    },

    async onUpdateDeepLink(): Promise<void> {
      Tasks.app.showConfirm({
        text: t('new_deeplink_confirm_message'),
        primaryText: t('common_yes'),
        async onSuccess() {
          await updateDeepLink({ groupId: source.group.id });
          Entities.toast.show(t('deeplink_created_message'));
        },
      });
    },
  }));

  return presenter;
};
